import MatomoTracker from ".";
function createInstance(params) {
    return new MatomoTracker(params);
}
export default createInstance;
